import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "Auth" */ '../views/Auth.vue'),
  },
  {
    path: '/navigation',
    name: 'Navigation',
    component: () => import(/* webpackChunkName: "Navigation" */ '../views/Navigation.vue'),
  },
  {
    path: '/reception/:type',
    name: 'Reception',
    component: () => import(/* webpackChunkName: "Reception" */ '../views/Reception.vue'),
    props: true,
  },
  {
    path: '/cars-by-zone/:id/:type',
    name: 'CarsByZone',
    component: () => import(/* webpackChunkName: "CarsByZone" */ '../views/CarsByZone.vue'),
    props: true,
  },
  {
    path: '/quality-attention/',
    name: 'QualityAttention',
    component: () => import('../views/QualityAttention.vue'),
  },
  {
    path: '/carrier-transmission',
    name: 'CarrierTransmission',
    component: () => import(/* webpackChunkName: "CarrierTransmission" */ '../views/CarrierTransmission.vue'),
  },
  {
    path: '/moving/:vin?',
    name: 'Moving',
    component: () => import(/* webpackChunkName: "Moving" */ '../views/Moving.vue'),
    props: true,
  },
  {
    path: '/moving-car-in-work/:vin',
    name: 'MovingCarInWork',
    props: true,
    component: () => import(/* webpackChunkName: "MovingCarInWork" */ '../views/MovingCarInWork.vue'),
  },
  {
    path: '/movement-shipping',
    name: 'MovementShipping',
    component: () => import(/* webpackChunkName: "MovementShipping" */ '../views/MovementShipping.vue'),
  },
  {
    path: '/cars-by-document/:id',
    name: 'CarsByDocument',
    component: () => import(/* webpackChunkName: "CarsByDocument" */ '../views/CarsByDocument.vue'),
    props: true,
  },
  {
    path: '/car-carriers',
    name: 'CarCarriers',
    component: () => import(/* webpackChunkName: "CarsByDocument" */ '../views/CarCarriers.vue'),
    props: true,
  },
  {
    path: '*',
    redirect: '/auth',
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
